import {AbstractControl, ValidatorFn} from '@angular/forms';
import moment from 'moment';

/**
 * validator to check if control value is equal or next to another hour
 * @param hourBegin
 */
export function hourAfterValidator(hourBegin: AbstractControl): ValidatorFn {
  return (control: AbstractControl): { [key: string]: {date: string} } | null => {
    if (hourBegin.value && moment(control.value).isBefore(moment(hourBegin.value), 'minute')) {
      return {hourAfter: {date: moment(hourBegin.value).format('HH:mm')}};
    }
    return null;
  };
}
